'use client'
import cn from 'classnames'
import { FC } from 'react'
import ReactCodeInput from 'react-code-input'
import styles from './CodeInput.module.scss'

interface CodeInputProps {
  value: string
  onChange: (value: string) => void
  name: string
  className?: string
}
export const CodeInput: FC<CodeInputProps> = ({
  value,
  onChange,
  name,
  className,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <ReactCodeInput
        className={styles.inputContainer}
        type="number"
        fields={6}
        name={name}
        value={value}
        onChange={onChange}
        placeholder="000000"
        inputMode="numeric"
      />
    </div>
  )
}
